import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogClose } from "app/components/ui/dialog";
import { Button } from "app/components/ui/button";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PreloadedSimNotRecognizedDialog = ({
  showDialog,
  setShowDialog,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent
        className="top-1/2 gap-0 bg-white w-[95%] sm:max-w-[33.5rem] p-4 sm:p-5 lg:p-6 border-[#E6E7EB] rounded-lg sm:rounded-xl"
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogClose className="absolute top-4 right-4 rounded-full md:top-5 md:right-5">
          <img
            src="/assets/close-circle.webp"
            className="flex-shrink-0 w-5 h-5 rounded-full opacity-90 md:w-6 md:h-6 hover:opacity-100"
            alt="Close"
          />
        </DialogClose>
        <div className="flex flex-col gap-3 sm:gap-3.5 lg:gap-4 items-center text-center">
          <div className="flex justify-center items-center bg-[#FFFAF6] size-[3.625rem] sm:size-16 lg:size-[4.375rem] rounded-full p-2.5">
            <img
              src="/assets/sad-emoji.svg"
              alt=""
              className="size-6 sm:size-[1.625rem] lg:size-7"
            />
          </div>
          <h3 className="font-mobile text-[#111827] text-lg sm:text-xl md:text-[1.375rem] lg:text-2xl font-bold leading-[1.375rem] sm:leading-6 md:leading-[1.625rem] lg:leading-7">
            SIM card not recognized
          </h3>
          <p className="text-[#6B7280] text-sm sm:text-[0.925rem] md:text-base font-medium leading-[1.125rem] sm:leading-5 md:leading-[1.375rem] max-w-md px-1">
            If your device does not have a preloaded plan, click{" "}
            <span className="text-[#FE4D01]">&quot;Purchase a plan&quot;</span>{" "}
            below to browse our plan bundles.
          </p>
          <Button
            type="button"
            variant="primary"
            className="w-full h-10 sm:h-[2.625rem] md:h-[2.75rem] lg:h-[2.875rem] mt-0.5 sm:mt-1"
            onClick={() => {
              setShowDialog(false);
              navigate("/network-plan");
            }}
          >
            Purchase a plan
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
